export type RegexExtract = {
  original: string;
  sanitised: string;
  templatePosition: number;
};

export function extractUsingRegex(
  template: string,
  findRegex: RegExp,
  sanitiseRegex?: RegExp
): RegexExtract[] {
  const iter = template.matchAll(findRegex);
  const matches: RegexExtract[] = [];

  while (true) {
    const part = iter.next();

    if (part.done) {
      break;
    }

    matches.push({
      original: part.value[0],
      sanitised: part.value[0].replaceAll(sanitiseRegex || /$^/g, ""), // /$^/g -> match nothing rule
      templatePosition: part.value.index!
    });
  }

  return matches;
}
